import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import {
  getListHopDongDelete,
  updateDataSearch,
} from "../../../../../actions/DanhSachHopDongDelete";
import { formatDayMonth } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import ReactDropdown from "react-dropdown";
import { ChoVayCombo } from "constants/choVayConst";
import userApi from "service/userApi";

export const SearchNangCao = (props) => {
  const DanhSachHopDongDeleteCombo = {
    KieuVayDefault: { value: "0", label: "Tất cả" },
    KieuVayCombo: [
      { value: "0", label: "Tất cả" },
      { value: "3", label: "Cầm đồ" },
      { value: "1", label: "Tín chấp" },
      { value: "2", label: "Trả góp" },
      { value: "5", label: "Bán hàng trả góp" },
    ],
    nguoiQuanLyOption: [
      {
        label: "Test828@gmail.com",
        value: "Test828@gmail.com",
      },
      {
        label: "Test@gmail.com",
        value: "Test@gmail.com",
        selected: true,
      },
    ],
  };

  const [listUser, setListUser] = useState(
    DanhSachHopDongDeleteCombo.nguoiGiaoDichOption
  );

  useEffect(() => {
    //Code lấy list user
    userApi.combo().then((response) => {
      const dataComboUser = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setListUser(dataComboUser);
    });
  }, []);

  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchHopDongDelete); //dataSearchTaiSan dinh nghia o rootreducer

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
        pageIndex: 1,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  // const updateDropdown1 = (field) => (e) => {
  //   updateState(field, e.value);
  // };

  const updateDropdown1 = (field) => (evt) => {
    updateState(field, evt.value);
  };
  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

  const onSearch = () => {
    props.onHide(false);
    dispatch(getListHopDongDelete(dataSearch));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: 1,
        })
      );
      dispatch(getListHopDongDelete(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  // convert sự kiện tìm kiếm từ ngày đến ngày
  var dateFrom = currentDate();
  if (dataSearch.dateFrom === "01/01/2001") dateFrom = "";
  else dateFrom = dataSearch.dateFrom;
  var dateTo = currentDate();
  if (dataSearch.dateTo === "01/01/4000") dateTo = "";
  else dateTo = dataSearch.dateTo;
  dateTo = convertDate(dateTo);
  dateFrom = convertDate(dateFrom);
  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 class="modal-title  color7-bold" id="myModalLabel16">
          <span class="btn-icon-right">
            <img src="/app-assets/images/icon-tim-kiem-nang-cao.png" />
          </span>
          Bộ lọc nâng cao
        </h4>
        <button type="button" className="close-popup-new" onClick={props.onHide}>
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="row repeater-default">
            <div className="form-group mb-1 col-sm-12 col-md-3">
              <label for="email-addr">Tên khách hàng</label>
              <br />
              <input
                className="form-control input-sm"
                value={dataSearch.NameCus}
                onChange={updateTextValue("NameCus")}
                onKeyDown={handleKeyDown}
                placeholder=""
              />
            </div>

            <div className="form-group mb-1 col-sm-12 col-md-3">
              <label for="bio" className="cursor-pointer">
                Số điện thoại
              </label>
              <br />
              <input
                className="form-control input-sm"
                value={dataSearch.SDT}
                onChange={updateTextValue("SDT")}
                onKeyDown={handleKeyDown}
                placeholder=""
              />
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3">
              <label for="tel-input">Địa chỉ</label>
              <br />
              <input
                className="form-control input-sm"
                value={dataSearch.DiaChi}
                onChange={updateTextValue("DiaChi")}
                onKeyDown={handleKeyDown}
                placeholder=""
              />
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3">
              <label for="tel-input">Từ ngày</label>
              <br />
              <DateTimePicker
                value={dateFrom}
                onChange={onChangeDate("dateFrom")}
                placeholder="Từ ngày"
                name="dateFrom"
              ></DateTimePicker>
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3">
              <label for="tel-input">Đến ngày</label>
              <br />
              <DateTimePicker
                value={dateTo}
                onChange={onChangeDate("dateTo")}
                placeholder="Đến ngày"
                name="dateFrom"
              ></DateTimePicker>
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3">
              <label for="tel-input">Số tiền vay</label>
              <br />
              <input
                className="form-control input-sm"
                placeholder=""
                value={dataSearch.SoTienVay}
                onChange={updateTextValue("SoTienVay")}
                onKeyDown={handleKeyDown}
              />
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3">
              <label for="tel-input">Người quản lý</label>
              <br />
              <select
                name="NameNQL"
                className="selectBox form-control input-sm"
                value={dataSearch.NameNQL}
                onChange={updateDropdown("NameNQL")}
              >
                {listUser &&
                  listUser.map((item, idx) => (
                    <option key={"objComboStore1" + idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
              </select>
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3">
              <label for="tel-input">Kiểu vay</label>
              {/* <select
                name="KieuVayID"
                className="selectBox form-control input-sm"
                value={dataSearch.KieuVayID}
                onChange={updateDropdown1("KieuVayID")}
              >
                {DanhSachHopDongDeleteCombo.KieuVayCombo &&
                  DanhSachHopDongDeleteCombo.KieuVayCombo.map((item, idx) => (
                    <option key={"objComboStore1" + idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
              </select> */}
              <ReactDropdown
                options={DanhSachHopDongDeleteCombo.KieuVayCombo}
                controlClassName="form-control input-sm"
                value={dataSearch.KieuVayID}
                onChange={updateDropdown1("KieuVayID")}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </button>
        <button
          type="button"
          class="btn btn-new-main btn-checknew"
          onClick={onSearch}
        >
          <span>
            <i class="mdi mdi-magnify"></i>
          </span>{" "}
          Tìm kiếm
        </button>
      </Modal.Footer>
    </Modal>
  );
};
